/** @jsx jsx */
import { hot } from 'react-hot-loader/root';
import { jsx, css } from '@emotion/core';
import { useStoreState, useStoreActions } from 'easy-peasy';

import * as S from './App.styles';
import { Button, DesktopOnly, MobileOnly } from '~/styles/index.styles';

import Icon from '~/core/scripts/components/Icon';
import DesktopSwipers from '~/components/DesktopSwipers';
import Presets from '~/components/Presets';
import MapDrawer from '~/components/MapDrawer';
import MobileSwiper from '~/components/MobileSwiper';

const redrawButtonStyles = (theme) => css`
  color: ${theme.colors.scissor};
  margin: var(--margin-vertical-lg, 8px) 0;
`;

const App = () => {
  const isDrawingEnabled = useStoreState((state) => state.app.isDrawingEnabled);
  const restartDrawing = useStoreActions(
    (actions) => actions.app.restartDrawing
  );

  const redrawButton = isDrawingEnabled ? null : (
    <Button
      css={redrawButtonStyles}
      onClick={() => {
        restartDrawing();
        if (typeof window !== 'undefined' && window.innerWidth < 992) {
          document
            .querySelector('.leaflet-container')
            .scrollIntoView({ behavior: 'smooth' });
        }
      }}
    >
      <Icon type="scissor" style={{ width: '1.2em' }} />
      &ensp;Neu schneiden
    </Button>
  );

  return (
    <S.AppWrapper>
      <S.LeftSidebar>
        <S.Topline>
          <S.Kicker>Deutsche Einheit</S.Kicker>
        </S.Topline>
        <S.Title>
          Ost-West? Nord-Süd?
          <br />
          Oder ganz anders?
        </S.Title>
        <S.SubTitle>Teile Deutschland und entdecke die Unterschiede</S.SubTitle>
        <S.IntroText>
          <p>
            Mehr als 30 Jahre nach der Wiedervereinigung bleibt Deutschland in vielen
            Belangen ein geteiltes Land. Doch die Grenzen verlaufen nicht nur
            zwischen Ost und West.
          </p>
          <S.HideAfterDraw isDrawingEnabled={isDrawingEnabled}>
            Zerschneide die Deutschlandkarte in zwei beliebige Teile und
            entdecke die Unterschiede bei 30 Merkmalen - von Millionärsdichte
            bis Graffiti!
          </S.HideAfterDraw>
        </S.IntroText>
        <DesktopSwipers />
        <DesktopOnly>{redrawButton}</DesktopOnly>
        <Presets />
      </S.LeftSidebar>
      <MapDrawer />
      <MobileSwiper />
      <MobileOnly>{redrawButton}</MobileOnly>
    </S.AppWrapper>
  );
};

export default hot(App);
